var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"info--text"},[_vm._v(_vm._s(_vm.article.title))]),_c('div',{staticClass:"body-1 pa-5",domProps:{"innerHTML":_vm._s(_vm.article.body)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }